import empty from "is-empty";

import Math from "./math";
import {
    SUPPORTED_CURRENCIES,
    COUNTRY_OPTIONS,
} from "../redux/MarketData/constants";

class CurrencyConversionService {
    constructor() {
        this._exRates = {};
        this._baseCurrency = "";
        this._targetCurrency = "";
    }

    setExRates(exRates, baseCurrency) {
        if (empty(exRates))
            throw new Error(
                "[CurrencyConverterService] NO exchange rates provided"
            );

        if (!SUPPORTED_CURRENCIES.includes(baseCurrency))
            throw new Error(
                "[CurrencyConverterService] Currency NOT supported"
            );

        this._exRates = exRates;
        this._baseCurrency = baseCurrency;
    }

    setTargetCurrency(targetCurrency) {
        if (!!targetCurrency && !SUPPORTED_CURRENCIES.includes(targetCurrency))
            throw new Error(
                "[CurrencyConverterService] Currency NOT supported"
            );

        this._targetCurrency = targetCurrency;
    }

    convertFromCountry(value, country) {
        return this.convert(value, COUNTRY_OPTIONS[country]?.currency);
    }

    convert(value, fromCurrency) {
        let converted;

        if (
            value === undefined ||
            value === null ||
            (!!fromCurrency && !SUPPORTED_CURRENCIES.includes(fromCurrency))
        ) {
            converted = null;
        } else if (
            empty(this._exRates) ||
            !this._baseCurrency ||
            !this._targetCurrency ||
            !fromCurrency ||
            fromCurrency === this._targetCurrency
        ) {
            converted = value;
        } else {
            converted = Math.chain(value)
                .divide(
                    fromCurrency === this._baseCurrency
                        ? 1
                        : this._exRates[this._baseCurrency + fromCurrency]
                )
                .multiply(
                    this._targetCurrency === this._baseCurrency
                        ? 1
                        : this._exRates[
                              this._baseCurrency + this._targetCurrency
                          ]
                )
                .done();
        }

        return new Converted(converted, fromCurrency, this._targetCurrency);
    }

    format(value) {
        if (value === undefined || value === null) return value;
        return CurrencyFormatter.format(value, this._targetCurrency);
    }
}

class Converted {
    constructor(value, fromCurrency, toCurrency) {
        this._value = value;
        this._fromCurrency = fromCurrency;
        this._toCurrency = toCurrency;
    }

    value() {
        return this._value;
    }

    format() {
        if (!this._fromCurrency) return this._value;
        if (!this._toCurrency)
            return CurrencyFormatter.format(this._value, this._fromCurrency);
        return CurrencyFormatter.format(this._value, this._toCurrency);
    }
}

export class CurrencyFormatter {
    static format(value, currency) {
        if (!currency) {
            return new Intl.NumberFormat("en-US").format(value);
        }
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currencyDisplay: "code",
            currency,
        })
            .format(value)
            .replace(/[a-zA-Z]{3}/i, "")
            .trim();
    }
}

const currencyConversionService = new CurrencyConversionService();

export default currencyConversionService;
